module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "left-wider": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Taco Email Logs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.loading == 'loaded') ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }], null, false, 892639569)
  }, [_vm._v(" "), _c('v-list', [(_vm.isAdministrator) ? _c('v-list-item', {
    on: {
      "click": _vm.showAll
    }
  }, [_c('v-list-item-title', [_vm._v("Show All")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.testMail('sendgrid')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Send Me a Test")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.testMail('smtp2go')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Send Me Test via Smtp2Go")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
    on: {
      "click": _vm.openConsole
    }
  }, [_c('v-list-item-title', [_vm._v("Open in Console")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (this.loading == 'loading') ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "indeterminate": ""
    },
    on: {
      "click": function($event) {
        this.loading = ''
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-2",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [(_vm.email) ? _c('v-chip', {
    staticClass: "ma-3",
    attrs: {
      "color": "primary",
      "close": ""
    },
    on: {
      "click:close": function($event) {
        return _vm.setEmail(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.email.split('@')[0]))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.logs), function(log, logIndex) {
    return _c('div', {
      key: logIndex,
      staticClass: "clickable log-tile",
      class: {
        'blue-hilight': _vm.isLogSelected(log)
      },
      on: {
        "click": function($event) {
          return _vm.selectLog(log._id)
        }
      }
    }, [_c('div', {
      staticClass: "bullet",
      class: {
        'green': _vm.logAllSuccessful(log), 'red': _vm.logHasProblems(log)
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.summariseTo(log.email.to)))]), _vm._v(" "), _c('span', {
      staticClass: "small-text light-text"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(log.createdAt)))]), _c('br'), _vm._v("\n            " + _vm._s(log.email.subject) + "\n        ")])
  }), _vm._v(" "), (this.limit == this.logs.length) ? _c('div', {
    staticClass: "pa-2"
  }, [_c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.limit = _vm.limit + 100
      }
    }
  }, [_vm._v("More")])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', [(this.logId && this.loading == 'loaded') ? _c('div', {
    staticClass: "pa-5 main-content"
  }, [_c('div', {
    staticClass: "pa-3 white rounded elevation-0"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("To")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listTo(_vm.selectedLog.email.to)))])]), _vm._v(" "), (_vm.listTo(_vm.selectedLog.email.cc)) ? _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Cc")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listTo(_vm.selectedLog.email.cc)))])]) : _vm._e(), _vm._v(" "), (_vm.listTo(_vm.selectedLog.email.bcc)) ? _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Bcc")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listTo(_vm.selectedLog.email.bcc)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("From")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedLog.email.from))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Subject")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedLog.email.subject))])]), _vm._v(" "), (_vm.selectedLog.email.attachments && _vm.selectedLog.email.attachments.length) ? _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Files")]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.attachmentsToHtml(_vm.selectedLog.email.attachments))
    }
  })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "solid 1px #ddd",
      "padding-top": "12px",
      "margin-top": "7px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLog.email.body)
    }
  })])])])]), _vm._v(" "), (!_vm.advanced) ? _c('v-btn', {
    staticClass: "mt-5",
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.advanced = true
      }
    }
  }, [_vm._v("Advanced")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 ml-2",
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("Resend")]), _vm._v(" "), (_vm.advanced && _vm.selectedLog.info) ? _c('div', {
    staticClass: "pa-3 white rounded elevation-2 mt-3 word-wrap"
  }, [_c('b', [_vm._v("Accepted addresses:")]), _c('br'), _vm._v(" "), _vm._l((_vm.selectedLog.info.accepted), function(address, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                    " + _vm._s(address) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Rejected addresses:")]), _c('br'), _vm._v(" "), _vm._l((_vm.selectedLog.info.rejected), function(address, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                    " + _vm._s(address) + "\n                ")])
  }), _vm._v(" "), (_vm.selectedLog.info.rejected.length === 0) ? _c('div', [_vm._v("None")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Nerdy Stuff")]), _c('br'), _vm._v("\n                mailId: " + _vm._s(_vm.selectedLog.mailId) + "\n                sendgridId: " + _vm._s(_vm.selectedLog.sendgridId) + "\n                " + _vm._s(JSON.stringify(_vm.selectedLog.info)) + "\n                "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Statuses")]), _vm._v(" "), _vm._l((_vm.selectedLog.statuses), function(statusVal, statusName, index) {
    return _c('div', {
      key: 'sts-' + index
    }, [_c('b', [_vm._v(_vm._s(statusName))]), _vm._v(" " + _vm._s(statusVal) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Events")]), _vm._v(" "), _vm._l((_vm.selectedLog.events), function(event, eventName, index) {
    return _c('div', {
      key: 'evt-' + index
    }, [_c('b', [_vm._v(_vm._s(eventName))]), _vm._v("\n                    " + _vm._s(JSON.stringify(event)) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Activity")]), _vm._v(" "), _vm._l((_vm.selectedLog.activities), function(activity, index) {
    return _c('div', {
      key: 'act-' + index
    }, [_c('b', [_vm._v(_vm._s(activity.event))]), _vm._v(" " + _vm._s(JSON.stringify(activity)) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Email")]), _vm._v("\n                " + _vm._s(JSON.stringify(_vm.selectedLog.email)) + "\n            ")], 2) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.selectedLog._id) ? _c('div', {
    staticClass: "pa-6 ma-5 white rounded activity-panel"
  }, [(_vm.queuedActivity(_vm.selectedLog)) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-icon', {
    staticClass: "blue--text",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "5px"
    }
  }, [_vm._v("view_week")]), _vm._v(" "), _c('div', {
    staticClass: "activity-description"
  }, [_vm._v(_vm._s(_vm.queuedActivity(_vm.selectedLog).event) + " " + _vm._s(_vm._f("time")(_vm.queuedActivity(_vm.selectedLog).time)))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vertical-line show-line"
  }), _vm._v(" "), (_vm.sentActivity(_vm.selectedLog)) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-icon', {
    staticClass: "blue--text",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "5px"
    }
  }, [_vm._v("local_post_office")]), _vm._v(" "), _c('div', {
    staticClass: "activity-description"
  }, [_vm._v(_vm._s(_vm.sentActivity(_vm.selectedLog).event) + " " + _vm._s(_vm._f("time")(_vm.sentActivity(_vm.selectedLog).time)))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vertical-line show-line"
  }), _vm._v(" "), (_vm.selectedLog.info) ? [_vm._l((_vm.selectedLog.info.accepted), function(email, index) {
    return _c('div', {
      key: 'eml-' + index,
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('v-tooltip', {
      attrs: {
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            staticClass: "recipient-bubble hoverable clickable",
            staticStyle: {
              "display": "flex"
            },
            on: {
              "click": function($event) {
                return _vm.setEmail(email)
              }
            }
          }, on), [_c('v-icon', {
            staticClass: "mr-1 grey--text"
          }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', [_c('div', {
            staticStyle: {
              "font-size": "14px",
              "margin-top": "-2px"
            }
          }, [_vm._v(_vm._s(email.split('@')[0]))]), _vm._v(" "), _c('div', {
            staticStyle: {
              "font-size": "10px",
              "margin-top": "-3px",
              "color": "#777"
            }
          }, [_vm._v("@" + _vm._s(email.split('@')[1]))])])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("See all my emails to " + _vm._s(email.split('@')[0]))])]), _vm._v(" "), _c('div', {
      staticClass: "vertical-line show-line"
    }), _vm._v(" "), _vm._l((_vm.getActivitiesForEmail(email)), function(activity, index) {
      return _c('div', {
        key: 'ue-' + index
      }, [_c('div', {
        staticStyle: {
          "display": "flex"
        }
      }, [(activity.event != 'deferred' && activity.event != 'bounce' && activity.event != 'open' && activity.event != 'dropped') ? _c('v-icon', {
        staticClass: "activity-icon blue--text"
      }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" "), (activity.event == 'deferred') ? _c('v-icon', {
        staticClass: "activity-icon orange--text"
      }, [_vm._v("watch_later")]) : _vm._e(), _vm._v(" "), (activity.event == 'bounce' || activity.event == 'dropped') ? _c('v-icon', {
        staticClass: "activity-icon red--text"
      }, [_vm._v("offline_bolt")]) : _vm._e(), _vm._v(" "), (activity.event == 'open') ? _c('v-icon', {
        staticClass: "activity-icon blue--text"
      }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "activity-description"
      }, [_vm._v(_vm._s(activity.event) + " " + _vm._s(_vm._f("time")(activity.time)))])], 1), _vm._v(" "), _c('div', {
        staticClass: "vertical-line",
        class: {
          'show-line': (index < _vm.getActivitiesForEmail(email).length - 1)
        }
      }, [_vm._v("\n                        " + _vm._s(activity.message) + "\n                    ")])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-5 small-text light-text"
  }, [_vm._v("\n            Sent with Taco " + _vm._s(_vm.selectedLog.provider) + "\n        ")])]), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2452cc54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MailLog.vue
// module id = 2486
// module chunks = 1